import {isNil} from 'ramda';

import {browserStorageKey} from '../constants/browserStorageKey';
import {WORKTREE_QUERY_PARAM} from '../constants/WORKTREE_QUERY_PARAM';

const IS_PRODUCTION_BUILD = process.env.NODE_ENV === 'production';

/**
 * Query params handing the current backend worktree over to IAM, which runs on its own origin and
 * therefore keeps its own copy of the override.
 *
 * The stored value is forwarded verbatim, including the empty string a cleared override leaves
 * behind — omitting it would leave IAM on a stale worktree and issue the auth code against the
 * wrong database. Nothing is added when the override was never used, so login URLs outside local
 * worktree development are unchanged.
 */
export function getWorktreeLoginParams(): Record<string, string> {
  if (IS_PRODUCTION_BUILD || typeof localStorage === 'undefined') {
    return {};
  }

  const storedWorktreeName = localStorage.getItem(browserStorageKey.WORKTREE_NAME);

  return isNil(storedWorktreeName) ? {} : {[WORKTREE_QUERY_PARAM]: storedWorktreeName};
}
